'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.addId = addId;
exports.removeId = removeId;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD = 'redux-frontend/lockscreen/ADD';
var REMOVE = 'redux-frontend/lockscreen/REMOVE';

var initialState = {
  ids: [],
  count: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ADD:
      return (0, _extends4.default)({}, state, {
        ids: state.ids.indexOf(action.id) >= 0 ? state.ids : [].concat((0, _toConsumableArray3.default)(state.ids), [action.id]),
        count: (0, _extends4.default)({}, state.count, (0, _defineProperty3.default)({}, action.id, (state.count[action.id] || 0) + 1))
      });
    case REMOVE:
      return (0, _extends4.default)({}, state, {
        ids: state.ids.indexOf(action.id) >= 0 ? [].concat((0, _toConsumableArray3.default)(state.ids.slice(0, state.ids.indexOf(action.id))), (0, _toConsumableArray3.default)(state.ids.slice(state.ids.indexOf(action.id) + 1))) : state.ids
      });
    default:
      return state;
  }
}

function addId(id) {
  return {
    type: ADD,
    id: id
  };
}

function removeId(id) {
  return {
    type: REMOVE,
    id: id
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/lockscreen.js
// module id = 154
// module chunks = 47